import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UsersService } from 'src/app/private/services/users.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-user',
  imports: [SharedModule],
  templateUrl: './delete-user.component.html',
  styleUrl: './delete-user.component.scss'
})
export class DeleteUserComponent {

  @Input() orgId: string = ''; // Organization ID passed from the parent component
  @Input() clientId: string = ''; // Client ID passed from the parent component
  @Input() userDataToEdit: any = ''; // Campus ID passed from the parent component
  @Output() close = new EventEmitter<void>();
  roleName: string = ''; // Campus name to be displayed in the confirmation dialog
  @Output() reload = new EventEmitter<void>(); // Event emitter to notify parent component for reloading data

  constructor(
    private userService: UsersService,
    private messageService: MessageService
  ) {
    // Initialize the campus name with the name of the campus to be deleted
    this.roleName = this.userDataToEdit.name
  }

  isLoading: boolean = false; // Loading state for the form submission
  handleCloseDialog() {
    this.close.emit();
  }

  ngOnInit() {
    console.log(this.userDataToEdit);
  }


  handleDeleteCampus() {
    this.isLoading = true; // Set loading state to true
    const payload = {
      client_id: this.clientId, // Use the organization ID passed from the parent component
      user_id: this.userDataToEdit.user_id // Use the campus ID passed from the parent component
    };
    this.userService.deleteUser(payload).subscribe(
      (response) => {
        this.isLoading = false; // Reset loading state
        this.close.emit(); // Emit close event to notify parent component
        this.reload.emit(); // Emit reload event to notify parent component for reloading data
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Campus deleted successfully!'
        });
      },
      (error) => {
        console.error('Error deleting campus:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete campus!'
        });

        this.isLoading = false; // Reset loading state on error
      }
    );
  }
}
